export default "__VITE_ASSET__BvauQfJK__"